/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * FormInput.tsx
 */

import HiloReactComponent from "../layout/HiloReactComponent";
import React from "react";
import {FormElementProps} from "./FormElement";
import {FormInputEvent} from "./FormInput";

interface Props<D> extends FormElementProps<D> {
    onChange?: FormInputEvent<D>;
}

interface State {
    value?: FileList
}

export default class FormFileInput<D> extends HiloReactComponent<Props<D>, State> {
    constructor(props: Props<D>, state: State) {
        super(props, state);

        let file = props.field.value;
        let stateBuilder: State = {};
        if (file instanceof FileList) stateBuilder.value = file as FileList

        this.state = stateBuilder
    }

    /**
     * componentDidUpdate
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    public componentDidUpdate(prevProps: Readonly<Props<D>>, prevState: Readonly<State>, snapshot?: any): void {
        if (this.state.value !== this.props.field.value && this.props.field.value instanceof FileList) {
            this.setState({value: this.props.field.value});
        }
    }

    /**
     * render
     * @returns {any}
     */
    public render() {
        const {field, onChange} = this.props;

        return <div className="field">
            <span>{field.title(this.t)}</span>
            <input className={"input"} type="file"
                   disabled={field.disabled} key={field.name}
                   onChange={event => {
                       if (!event.target.files || !onChange) return

                       onChange?.(field.name, event.target.files as unknown as D);
                   }}
            />
        </div>;
    }
}